import { render, staticRenderFns } from "./update-task.vue?vue&type=template&id=9ca8dd40&"
import script from "./update-task.vue?vue&type=script&lang=js&"
export * from "./update-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports